import React, { Component } from 'react';

import { Button, Form, Input } from 'antd';

import LoginRightSection from 'containers/LoginRightSection';

import CircularProgress from 'components/CircularProgress';

import axios from 'util/Api';
import IntlMessages from 'util/IntlMessages';
import { history } from 'util/history';

import { PROJECT_DETAILS } from 'constants/Common';

import OpenNotification from '../../../constants/OpenNotifications';

const FormItem = Form.Item;

class ResetPassword extends Component {
  state = {
    loading: false,
    resetId: this.props.match.params.resetId,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        if (!err) {
          axios
            .post('/auth/reset-password', {
              token: this.state.resetId,
              newPassword: values.confirm,
            })
            .then(({ data }) => {
              if (data.code === 'OK') {
                OpenNotification({
                  type: 'success',
                  title: data.message,
                });
                this.props.form.resetFields();
                history.push('/');
              } else if (data.message) {
                OpenNotification({
                  type: 'error',
                  title: data.message,
                });
              }
              this.setState({
                loading: false,
              });
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });
              OpenNotification({
                type: 'error',
                title: error.message,
              });
            });
        }
      }
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.props.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="adma-login-wrap">
        {this.state.loading && <CircularProgress className="fixLoader" />}
        <div className="adma-login-container">
          <div className="loginpage">
            <div className="adma-login-main-content">
              <div className="adma-app-login-content">
                <div className="adma-logo-content-bg">
                  <img
                    width="auto"
                    height="80px"
                    style={{ objectFit: 'contain', textAlign: 'left' }}
                    src={PROJECT_DETAILS.LOGO_1}
                    alt="P N Shah"
                  />
                  <h2>Reset Password</h2>
                  <p>
                    <IntlMessages id="appModule.enterPasswordReset" />
                  </p>
                </div>
                <Form layout="vertical" onSubmit={this.handleSubmit} className="gx-login-form gx-form-row0">
                  <FormItem>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password!',
                        },
                        {
                          validator: this.validateToNextPassword,
                        },
                      ],
                    })(<Input type="password" placeholder="New Password" />)}
                  </FormItem>

                  <FormItem>
                    {getFieldDecorator('confirm', {
                      rules: [
                        {
                          required: true,
                          message: 'Please confirm your password!',
                        },
                        {
                          validator: this.compareToFirstPassword,
                        },
                      ],
                    })(<Input placeholder="Retype New Password" type="password" onBlur={this.handleConfirmBlur} />)}
                  </FormItem>
                  <div className="submit-btn">
                    <Form.Item>
                      <Button type="primary" className="adma-mb-0" htmlType="submit">
                        <IntlMessages id="app.userAuth.reset" />
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              </div>
            </div>
            <LoginRightSection />
          </div>
        </div>
      </div>
    );
  }
}

const WrappedResetPasswordForm = Form.create()(ResetPassword);

export default WrappedResetPasswordForm;
